import React from 'react';
import PropTypes from 'prop-types';
import Layout from './Layout';

export default function BarSection({
    children,
    className,
    size,
    ...props
}) {
    return React.createElement(
        size === 'flex' ? Layout.Flex : Layout.Fixed,
        { ...props, className },
        children
    );
}

BarSection.defaultProps = {
    size: 'flex',
};

BarSection.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    size: PropTypes.oneOf(['flex', 'fixed']).isRequired,
};
